module.exports = __webpack_public_path__ + "d78b2a3ea9ab3870fbc77e69bbc59c2b.svg";